module.exports = __webpack_public_path__ + "img/0Q3B3739_L_Foamcore_MockedUp.4502017e.jpg";